//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LineageBi',
  props: {
    datos: {
      type: Object,
      default: function _default() {}
    },
    class_main: {
      type: String,
      default: 'lineage-dataset'
    }
  },
  computed: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    isShowPages: function isShowPages(report) {
      return report.show_pages;
    },
    showPages: function showPages(report) {
      this.$set(report, 'show_pages', !report.show_pages);
    },
    getNameFile: function getNameFile(url) {
      var splitUrl = url.split("/");
      return splitUrl[splitUrl.length - 1];
    },
    getClassMain: function getClassMain() {
      var key = 'lineage lineage-dataset ' + this.class_main;
      return {
        key: true,
        'lineage lineage-dataset': 12 < 100
      };
    }
  }
};